import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import './head.scss';
import { Menu, Dropdown, Input } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import { Context } from '@/models/home';

const { Search } = Input;

function Head() {
  let history = useHistory();
  const HomeContext = useContext(Context);

  const getQueryVariable = (variable) => {
    var query = window.location.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split('=');
      if (pair[0] === variable) {
        return pair[1];
      }
    }
    return false;
  };

  history.listen((route) => {
    setTitleArr(decodeURI(getQueryVariable('title')).split('/'));
  });

  const [titleArr, setTitleArr] = useState(
    decodeURI(getQueryVariable('title')).split('/'),
  );

  useEffect(() => {
    actStyle();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [titleArr]);

  const actStyle = () => {
    initStyle();
    switch (titleArr[0]) {
      case '资讯中心':
        document.querySelectorAll(
          '.ant-dropdown-trigger',
        )[0].style.backgroundImage = 'linear-gradient(#539ce1, #2981d7)';
        break;
      case '学术与规划':
        document.querySelectorAll(
          '.ant-dropdown-trigger',
        )[1].style.backgroundImage = 'linear-gradient(#539ce1, #2981d7)';
        break;
      case '科普园地':
        document.querySelectorAll(
          '.ant-dropdown-trigger',
        )[2].style.backgroundImage = 'linear-gradient(#539ce1, #2981d7)';
        break;
      case '品牌活动':
        document.querySelectorAll(
          '.ant-dropdown-trigger',
        )[3].style.backgroundImage = 'linear-gradient(#539ce1, #2981d7)';
        break;
      case '会员之家':
        document.querySelectorAll(
          '.ant-dropdown-trigger',
        )[4].style.backgroundImage = 'linear-gradient(#539ce1, #2981d7)';
        break;
      case '《江苏通信》':
        document.querySelectorAll(
          '.ant-dropdown-trigger',
        )[5].style.backgroundImage = 'linear-gradient(#539ce1, #2981d7)';
        break;
      case '标准化':
        document.querySelectorAll(
          '.ant-dropdown-trigger',
        )[6].style.backgroundImage = 'linear-gradient(#539ce1, #2981d7)';
        break;
      case '科技服务':
        document.querySelectorAll(
          '.ant-dropdown-trigger',
        )[7].style.backgroundImage = 'linear-gradient(#539ce1, #2981d7)';
        break;
      case '关于学会':
        document.querySelectorAll(
          '.ant-dropdown-trigger',
        )[8].style.backgroundImage = 'linear-gradient(#539ce1, #2981d7)';
        break;

      default:
        break;
    }
  };

  const onSearch = (value) => {
    // console.log(value);
    history.push(`list?title=ssjg&keywords=${value}`);
  };

  const toRouter = (path) => {
    history.push(path);
  };

  const toMenu = (title) => {
    HomeContext.state.menuList &&
      Object.keys(HomeContext.state.menuList).map((i) => {
        HomeContext.state.menuList[i].map((item) => {
          if (item.title === HomeContext.state.menuTitleList[title]) {
            history.push(item.path);
          }
          return null;
        });
        return null;
      });
    HomeContext.state.newsTypeList &&
      HomeContext.state.newsTypeList.map((i) => {
        if (i.name === HomeContext.state.menuTitleList[title]) {
          history.push(
            `/list?title=${HomeContext.state.menuTitleList[title]}&id=${i.id}&isMenu=true`,
          );
        }
        return null;
      });
  };

  const onClick = ({ key }) => {
    toMenu(key);
  };

  const menu1 = (
    <Menu onClick={onClick} id="menu1">
      <Menu.Item key="公告栏">
        <RightOutlined />
        公告栏
      </Menu.Item>
      <Menu.Item key="学会动态">
        <RightOutlined />
        学会动态
      </Menu.Item>
      <Menu.Item key="分支机构动态">
        <RightOutlined />
        分支机构动态
      </Menu.Item>
      <Menu.Item key="地市学会动态">
        <RightOutlined />
        地市学会动态
      </Menu.Item>
    </Menu>
  );
  const menu2 = (
    <Menu onClick={onClick} id="menu2">
      <Menu.Item key="前瞻技术">
        <RightOutlined />
        前瞻技术
      </Menu.Item>
      <Menu.Item key="法规与政策">
        <RightOutlined />
        法规与政策
      </Menu.Item>
      <Menu.Item key="规划与发展">
        <RightOutlined />
        规划与发展
      </Menu.Item>
      <Menu.Item key="行业要闻">
        <RightOutlined />
        行业要闻
      </Menu.Item>
    </Menu>
  );
  const menu3 = (
    <Menu onClick={onClick} id="menu3">
      <Menu.Item key="科普作品">
        <RightOutlined />
        科普作品
      </Menu.Item>
      <Menu.Item key="科普视频">
        <RightOutlined />
        科普视频
      </Menu.Item>
      <Menu.Item key="科普场馆">
        <RightOutlined />
        科普场馆
      </Menu.Item>
    </Menu>
  );
  const menu4 = (
    <Menu onClick={onClick} id="menu4">
      <Menu.Item key="世界电信和信息社会日纪念大会">
        <RightOutlined />
        世界电信和信息社会日纪念大会
      </Menu.Item>
      <Menu.Item key="江苏信息通信行业科学技术奖">
        <RightOutlined />
        江苏信息通信行业科学技术奖
      </Menu.Item>
      <Menu.Item key="青年学术论坛">
        <RightOutlined />
        青年学术论坛
      </Menu.Item>
      <Menu.Item key="论文征集">
        <RightOutlined />
        论文征集
      </Menu.Item>
    </Menu>
  );
  const menu5 = (
    <Menu onClick={onClick} id="menu5">
      <Menu.Item key="会员单位">
        <RightOutlined />
        会员单位
      </Menu.Item>
      <Menu.Item key="会员动态">
        <RightOutlined />
        会员动态
      </Menu.Item>
      <Menu.Item key="合作需求">
        <RightOutlined />
        合作需求
      </Menu.Item>
    </Menu>
  );
  const menu6 = (
    <Menu onClick={onClick} id="menu6">
      <Menu.Item key="近期目录">
        <RightOutlined />
        近期目录
      </Menu.Item>
      <Menu.Item key="征稿启事">
        <RightOutlined />
        征稿启事
      </Menu.Item>
      <Menu.Item key="论文集">
        <RightOutlined />
        论文集
      </Menu.Item>
    </Menu>
  );
  const menu7 = (
    <Menu onClick={onClick} id="menu7">
      <Menu.Item key="团体标准">
        <RightOutlined />
        团体标准
      </Menu.Item>
      <Menu.Item key="地方标准">
        <RightOutlined />
        地方标准
      </Menu.Item>
      <Menu.Item key="行业标准">
        <RightOutlined />
        行业标准
      </Menu.Item>
      <Menu.Item key="国家标准">
        <RightOutlined />
        国家标准
      </Menu.Item>
    </Menu>
  );
  const menu8 = (
    <Menu onClick={onClick} id="menu8">
      <Menu.Item key="咨询与智库">
        <RightOutlined />
        咨询与智库
      </Menu.Item>
      <Menu.Item key="科技评价">
        <RightOutlined />
        科技评价
      </Menu.Item>
    </Menu>
  );
  const menu9 = (
    <Menu onClick={onClick} id="menu9">
      <Menu.Item key="党的建设">
        <RightOutlined />
        党的建设
      </Menu.Item>
      <Menu.Item key="学会简介">
        <RightOutlined />
        学会简介
      </Menu.Item>
      <Menu.Item key="学会章程">
        <RightOutlined />
        学会章程
      </Menu.Item>
      <Menu.Item key="组织架构">
        <RightOutlined />
        组织架构
      </Menu.Item>
      <Menu.Item key="理事会名单">
        <RightOutlined />
        理事会名单
      </Menu.Item>
      <Menu.Item key="监事会名单">
        <RightOutlined />
        监事会名单
      </Menu.Item>
      <Menu.Item key="分支机构">
        <RightOutlined />
        分支机构
      </Menu.Item>
      <Menu.Item key="地市学会">
        <RightOutlined />
        地市学会
      </Menu.Item>
      <Menu.Item key="管理办法">
        <RightOutlined />
        管理办法
      </Menu.Item>
      <Menu.Item key="加入学会">
        <RightOutlined />
        加入学会
      </Menu.Item>
      <Menu.Item key="联系我们">
        <RightOutlined />
        联系我们
      </Menu.Item>
    </Menu>
  );

  const initStyle = () => {
    const docArr = [...document.querySelectorAll('.ant-dropdown-trigger')];
    docArr.map((item) => {
      item.style.backgroundImage = 'none';
      return null;
    });
  };

  return (
    <div>
      <div className="headerBox">
        <div className="center logo">
          <div>
            <img src={require('@/assets/home/logo.png').default} alt=""></img>
            <img src={require('@/assets/home/topTitle.png').default} alt=""></img>
          </div>
          <div className="search">
            <Search
              placeholder="请输入关键字"
              allowClear
              onSearch={onSearch}
              style={{ margin: '0 10px' }}
            />
          </div>
        </div>
      </div>
      <div className="menu">
        {/* <ul className="clearfix center">
          <li onClick={toRouter.bind(this, '')}>首页</li>
          <li onClick={toMenu.bind(this, '资讯中心')}>资讯中心</li>
          <li onClick={toMenu.bind(this, '学术与规划')}>学术与规划</li>
          <li onClick={toMenu.bind(this, '科普园地')}>科普园地</li>
          <li onClick={toMenu.bind(this, '品牌活动')}>品牌活动</li>
          <li onClick={toMenu.bind(this, '会员之家')}>会员之家</li>
          <li onClick={toMenu.bind(this, '《江苏通信》')}>《江苏通信》</li>
          <li onClick={toMenu.bind(this, '标准化')}>标准化</li>
          <li onClick={toMenu.bind(this, '科技服务')}>科技服务</li>
          <li onClick={toMenu.bind(this, '关于学会')}>关于学会</li>
        </ul> */}
        <span onClick={toRouter.bind(this, '')}>
          <div>首页</div>
        </span>
        <b>|</b>
        <Dropdown
          className={titleArr[0] === 'zxzx' ? 'act' : ''}
          onClick={toMenu.bind(this, '资讯中心')}
          overlay={menu1}
          onVisibleChange={(flag) => {
            // actStyle();
            // document.querySelectorAll(
            //   '.ant-dropdown-trigger',
            // )[0].style.backgroundImage = flag
            //     ? 'linear-gradient(#539ce1, #2981d7)'
            //     : 'none';
            if (flag) {
              document.querySelectorAll(
                '.ant-dropdown-trigger',
              )[0].style.backgroundImage = 'linear-gradient(#539ce1, #2981d7)';
            } else {
              actStyle();
            }
          }}
        >
          <div>资讯中心</div>
        </Dropdown>
        <b>|</b>
        <Dropdown
          className={titleArr[0] === 'xsygh' ? 'act' : ''}
          onClick={toMenu.bind(this, '学术与规划')}
          overlay={menu2}
          onVisibleChange={(flag) => {
            // actStyle();
            // document.querySelectorAll(
            //   '.ant-dropdown-trigger',
            // )[1].style.backgroundImage = flag
            //     ? 'linear-gradient(#539ce1, #2981d7)'
            //     : 'none';

            if (flag) {
              document.querySelectorAll(
                '.ant-dropdown-trigger',
              )[1].style.backgroundImage = 'linear-gradient(#539ce1, #2981d7)';
            } else {
              actStyle();
            }
          }}
        >
          <div>学术与规划</div>
        </Dropdown>
        <b>|</b>
        <Dropdown
          className={titleArr[0] === 'kpyd' ? 'act' : ''}
          onClick={toMenu.bind(this, '科普园地')}
          overlay={menu3}
          onVisibleChange={(flag) => {
            // actStyle();
            // document.querySelectorAll(
            //   '.ant-dropdown-trigger',
            // )[2].style.backgroundImage = flag
            //     ? 'linear-gradient(#539ce1, #2981d7)'
            //     : 'none';

            if (flag) {
              document.querySelectorAll(
                '.ant-dropdown-trigger',
              )[2].style.backgroundImage = 'linear-gradient(#539ce1, #2981d7)';
            } else {
              actStyle();
            }
          }}
        >
          <div>科普园地</div>
        </Dropdown>
        <b>|</b>
        <Dropdown
          className={titleArr[0] === 'pphd' ? 'act' : ''}
          onClick={toMenu.bind(this, '品牌活动')}
          overlay={menu4}
          onVisibleChange={(flag) => {
            // actStyle();
            // document.querySelectorAll(
            //   '.ant-dropdown-trigger',
            // )[3].style.backgroundImage = flag
            //     ? 'linear-gradient(#539ce1, #2981d7)'
            //     : 'none';

            if (flag) {
              document.querySelectorAll(
                '.ant-dropdown-trigger',
              )[3].style.backgroundImage = 'linear-gradient(#539ce1, #2981d7)';
            } else {
              actStyle();
            }
          }}
        >
          <div>品牌活动</div>
        </Dropdown>
        <b>|</b>
        <Dropdown
          className={titleArr[0] === 'hyfc' ? 'act' : ''}
          onClick={toMenu.bind(this, '会员之家')}
          overlay={menu5}
          onVisibleChange={(flag) => {
            // actStyle();
            // document.querySelectorAll(
            //   '.ant-dropdown-trigger',
            // )[4].style.backgroundImage = flag
            //     ? 'linear-gradient(#539ce1, #2981d7)'
            //     : 'none';

            if (flag) {
              document.querySelectorAll(
                '.ant-dropdown-trigger',
              )[4].style.backgroundImage = 'linear-gradient(#539ce1, #2981d7)';
            } else {
              actStyle();
            }
          }}
        >
          <div>会员之家</div>
        </Dropdown>
        <b>|</b>
        <Dropdown
          className={titleArr[0] === 'jstx' ? 'act' : ''}
          onClick={toMenu.bind(this, '《江苏通信》')}
          overlay={menu6}
          onVisibleChange={(flag) => {
            // actStyle();
            // document.querySelectorAll(
            //   '.ant-dropdown-trigger',
            // )[5].style.backgroundImage = flag
            //     ? 'linear-gradient(#539ce1, #2981d7)'
            //     : 'none';

            if (flag) {
              document.querySelectorAll(
                '.ant-dropdown-trigger',
              )[5].style.backgroundImage = 'linear-gradient(#539ce1, #2981d7)';
            } else {
              actStyle();
            }
          }}
        >
          <div>《江苏通信》</div>
        </Dropdown>
        <b>|</b>
        <Dropdown
          className={titleArr[0] === 'bzh' ? 'act' : ''}
          onClick={toMenu.bind(this, '标准化')}
          overlay={menu7}
          onVisibleChange={(flag) => {
            // actStyle();
            // document.querySelectorAll(
            //   '.ant-dropdown-trigger',
            // )[6].style.backgroundImage = flag
            //     ? 'linear-gradient(#539ce1, #2981d7)'
            //     : 'none';

            if (flag) {
              document.querySelectorAll(
                '.ant-dropdown-trigger',
              )[6].style.backgroundImage = 'linear-gradient(#539ce1, #2981d7)';
            } else {
              actStyle();
            }
          }}
        >
          <div>标准化</div>
        </Dropdown>
        <b>|</b>
        <Dropdown
          className={titleArr[0] === 'kjfw' ? 'act' : ''}
          onClick={toMenu.bind(this, '科技服务')}
          overlay={menu8}
          onVisibleChange={(flag) => {
            // actStyle();
            // document.querySelectorAll(
            //   '.ant-dropdown-trigger',
            // )[7].style.backgroundImage = flag
            //     ? 'linear-gradient(#539ce1, #2981d7)'
            //     : 'none';

            if (flag) {
              document.querySelectorAll(
                '.ant-dropdown-trigger',
              )[7].style.backgroundImage = 'linear-gradient(#539ce1, #2981d7)';
            } else {
              actStyle();
            }
          }}
        >
          <div>科技服务</div>
        </Dropdown>
        <b>|</b>
        <Dropdown
          className={titleArr[0] === 'gyxh' ? 'act' : ''}
          onClick={toMenu.bind(this, '关于学会')}
          overlay={menu9}
          onVisibleChange={(flag) => {
            // actStyle();
            // document.querySelectorAll(
            //   '.ant-dropdown-trigger',
            // )[8].style.backgroundImage = flag
            //     ? 'linear-gradient(#539ce1, #2981d7)'
            //     : 'none';

            if (flag) {
              document.querySelectorAll(
                '.ant-dropdown-trigger',
              )[8].style.backgroundImage = 'linear-gradient(#539ce1, #2981d7)';
            } else {
              actStyle();
            }
          }}
        >
          <div>关于学会</div>
        </Dropdown>
      </div>
      {/* <ul className="lisBox clearfix">
        <div className="liBox">
          <div>
            {HomeContext.state.menuList && menuTitle
              ? HomeContext.state.menuList[menuTitle].map((item, index) => {
                  return (
                    item.title && (
                      <li key={index} onClick={toRouter.bind(this, item.path)}>
                        <RightOutlined /> {item.title}
                      </li>
                    )
                  );
                })
              : null}
          </div>
        </div>
      </ul> */}
    </div>
  );
}
export default Head;
